import * as Ariakit from '@ariakit/react';
import styled, { css } from 'styled-components';
import { easeInOutCubic, timingFast, timingFaster, zIndexModal } from '../../constants';
import { SelectMark } from '../Icons';
import { TypeStyle } from '../TypeStyle';
export const Backdrop = styled.div `
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: ${zIndexModal - 1};
  opacity: 0;
  transition: ${timingFaster} ${easeInOutCubic} opacity;
  &[data-enter] {
    opacity: 1;
  }
`;
export const Header = styled.div `
  display: flex;
  flex-direction: ${o => (o.$reverse === true ? 'row-reverse' : 'row')};
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: ${o => o.theme.spacing(4)};
  ${o => o.$borderless === false &&
    css `
      border-bottom: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
    `}
`;
export const Title = styled(Ariakit.DialogHeading) `
  ${TypeStyle.css.headlineExtraSmall};
  flex-grow: 1;
  flex-basis: 100%;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: ${o => o.$align === 'center' ? 'center' : o.$align === 'right' ? 'flex-end' : 'flex-start'};
  gap: ${o => o.theme.spacing(2)};
`;
export const Content = styled.div `
  position: relative;
  height: 100%;
  padding: ${o => o.theme.spacing(6, 4)};
`;
export const CloseIconButton = styled.button `
  padding: ${o => o.theme.spacing(1)};
  transition: ${timingFast} ${easeInOutCubic} opacity;
  &:hover {
    opacity: 0.5;
  }
`;
export const Dismiss = styled(Ariakit.DialogDismiss) ``;
export const CloseIcon = styled(SelectMark) `
  display: block;
`;
export const Footer = styled.div `
  border-top: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  padding: ${o => o.theme.spacing(4)};
`;
//# sourceMappingURL=styles.js.map